<script lang="ts">
  import { defineAsyncComponent, defineComponent } from 'vue'

  export default defineComponent({
    name: 'TheAppLayout',
    components: {
      TheTopMenuLoggedOut: defineAsyncComponent(() => import('@/components/common/TheTopMenuLoggedOut.vue')),
      IndexModal: defineAsyncComponent(() => import('@/components/modal/IndexModal.vue')),
    },
    data() {
      return {
        isLoading: true,
      }
    },
  })
</script>

<template>
  <div class="wrapper">
    <div class="h-100 overflow-hidden">
      <TheTopMenuLoggedOut />
      <main class="d-flex flex-column w-100 pa-5">
        <router-view />
      </main>
    </div>
  </div>
  <IndexModal />
  <IndexNotification />
</template>

<style scoped lang="scss">
  .notification-block {
    max-width: 450px;
    margin: 0 auto;
  }
</style>
